import { AdditionalInformation } from "us.collection.debtor/constants/Actions";
import { IAPIAction } from "us.collection/interfaces/API";

const {
  GET_ADDITIONAL_INFORMATION,
  GET_ADDITIONAL_INFORMATION_SUCCESS,
  GET_ADDITIONAL_INFORMATION_FAIL,

  HANDLE_ADDITIONAL_INFORMATION_DRAWER,
  RESET_ADDITIONAL_INFORMATION_DATA,

  NEW_ADDITIONAL_INFORMATION,
  NEW_ADDITIONAL_INFORMATION_SUCCESS,
  NEW_ADDITIONAL_INFORMATION_FAIL,

  UPDATE_ADDITIONAL_INFORMATION,
  UPDATE_ADDITIONAL_INFORMATION_SUCCESS,
  UPDATE_ADDITIONAL_INFORMATION_FAIL,

  DELETE_ADDITIONAL_INFORMATION,
  DELETE_ADDITIONAL_INFORMATION_SUCCESS,
  DELETE_ADDITIONAL_INFORMATION_FAIL,

  GET_INFORMATION_META_DATA,
  GET_INFORMATION_META_DATA_SUCCESS,
  GET_INFORMATION_META_DATA_FAIL,

  GET_DATA_TYPE_VALUES,
  GET_DATA_TYPE_VALUES_SUCCESS,
  GET_DATA_TYPE_VALUES_FAIL,
} = AdditionalInformation;

export const additionalInformation: Readonly<IAPIAction> = {
  informationList: {
    get: (data) => ({
      type: GET_ADDITIONAL_INFORMATION,
      payload: {
        data,
        isLoading: true,
      },
    }),
    openDrawer: (data) => ({
      type: HANDLE_ADDITIONAL_INFORMATION_DRAWER,
      payload: {
        data,
        isLoading: true,
      },
    }),
    reset: (data) => ({
      type: RESET_ADDITIONAL_INFORMATION_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_ADDITIONAL_INFORMATION_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_ADDITIONAL_INFORMATION_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  newInformation: {
    save: (data) => ({
      type: NEW_ADDITIONAL_INFORMATION,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: NEW_ADDITIONAL_INFORMATION_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: NEW_ADDITIONAL_INFORMATION_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  informationDetails: {
    update: (data) => ({
      type: UPDATE_ADDITIONAL_INFORMATION,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: UPDATE_ADDITIONAL_INFORMATION_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: UPDATE_ADDITIONAL_INFORMATION_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  deleteInformation: {
    save: (data) => ({
      type: DELETE_ADDITIONAL_INFORMATION,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: DELETE_ADDITIONAL_INFORMATION_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: DELETE_ADDITIONAL_INFORMATION_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  informationMetaData: {
    get: (data) => ({
      type: GET_INFORMATION_META_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_INFORMATION_META_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_INFORMATION_META_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  bmdDataTypeValues: {
    get: (data) => ({
      type: GET_DATA_TYPE_VALUES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DATA_TYPE_VALUES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DATA_TYPE_VALUES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
